import React, { useRef, useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import Download from "../../components/Download";
import { CachedImage } from "../../components/CachedImage"; 
import { useNavigate } from "react-router-dom";
import { globalStore } from "../../GlobalStore";
import { PAGE_INLINE_PADDING_PX } from "../../constants/pageLayout";
import {
  PropertySafetyOutlined,
  
  UserOutlined, 
  FileTextOutlined,
  StarOutlined,
  AuditOutlined,
  StopOutlined,
} from "@ant-design/icons";

const Home: React.FC = observer(() => {
  const homePageAdsData = globalStore.homePageAdsData;
  const secondRef = useRef<HTMLDivElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const [showDownload, setShowDownload] = useState(false); 
  const [currentSellerIndex, setCurrentSellerIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // 滚动到页面顶部
    window.scrollTo(0, 0); 
  }, []);

  useEffect(() => {
    if ((homePageAdsData?.length ?? 0) > 0) {
      setCurrentSellerIndex(0);
      const timer = setInterval(() => {
        setCurrentSellerIndex((prev) => (prev + 1) % (homePageAdsData?.length ?? 1));
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [homePageAdsData]);

  const scrollToSecond = () => {
    secondRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleVideoLoaded = () => {
    setVideoLoaded(true);
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  };

  const handleVideoError = () => {
    setVideoError(true);
  };

  const playVideo = () => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  };

  const handleRemoteTrainingClick = () => {
    globalStore.selectedMenuKey = 'daily-delivery';
    navigate('/remote-delivery');
  };

  return (
    <div style={{ width: "100%", background: "#ffffff" }}>
      {/* ====== 首屏：全屏视频背景（左文案 / 右下载区） ====== */}
      <section
        style={{
          position: "relative",
          width: "100%",
          height: "100vh",
          overflow: "hidden",
        }}
      > 

        {/* 纯色背景遮罩 */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "#013510",
          }}
        />

        {/* 内容层：左右结构容器 */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 24px",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "1200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "48px",
              flexWrap: "wrap", // 小屏自动换行为上下结构
            }}
          >
            {/* 左侧：标题 + 文案 + CTA */}
            <div
              style={{
                flex: "1 1 520px",
                minWidth: "300px",
                color: "#ffffff",
                padding: "32px",
              }}
            >
              <h1
                style={{
                  margin: 0,
                  fontSize: "48px",
                  lineHeight: 1.08,
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                  textShadow: "0 4px 8px rgba(0,0,0,0.8), 0 2px 4px rgba(0,0,0,0.6)",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.5))",
                }}
              >
                以结果为导向的远程交付
              </h1>
              <p
                style={{
                  margin: "18px 0 28px 0",
                  fontSize: "18px",
                  lineHeight: 1.6,
                  opacity: 0.95,
                  maxWidth: "680px",
                  textShadow: "0 2px 4px rgba(0,0,0,0.7), 0 1px 2px rgba(0,0,0,0.5)",
                  filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.4))",
                }}
              >
                我们用实践证明任何公司都可以通过远程革命实现1.5～3倍的人效提升，丢掉考勤、打卡和日报，拥抱可视化交付！AI时代下，工作方式正在发生革命性变化。
              </p>

              <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                <button
                  onClick={scrollToSecond}
                  style={{
                    padding: "12px 20px",
                    paddingInline: "30px",
                    borderRadius: "4px",
                    border: "1px solid rgba(255,255,255,0.4)",
                    background: "rgba(255,255,255,0.15)",
                    color: "#fff",
                    backdropFilter: "blur(10px)",
                    cursor: "pointer",
                    fontSize: "14px",
                    textShadow: "0 1px 2px rgba(0,0,0,0.6)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2)",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.25)";
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.15)";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2)";
                  }}
                >
                  平台理念
                </button>
                <button
                  onClick={handleRemoteTrainingClick}
                  style={{
                    padding: "12px 20px",
                    paddingInline: "30px",
                    borderRadius: "4px",
                    border: "1px solid rgba(255,255,255,0.4)",
                    background: "rgba(255,255,255,0.15)",
                    color: "#fff",
                    backdropFilter: "blur(10px)",
                    cursor: "pointer",
                    fontSize: "14px",
                    textShadow: "0 1px 2px rgba(0,0,0,0.6)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2)",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.25)";
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.15)";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2)";
                  }}
                >
                  远程培训
                </button>
                <button
                  onClick={() => setShowDownload(true)}
                  style={{
                    padding: "12px 20px",
                    paddingInline: "30px",
                    borderRadius: "4px",
                    border: "0",
                    background:
                      "linear-gradient(135deg, #2DD4BF 0%, #60A5FA 100%)",
                    color: "#0b1220",
                    cursor: "pointer",
                    fontSize: "14px", 
                    fontWeight: 700,
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 12px rgba(45, 212, 191, 0.4), 0 2px 4px rgba(96, 165, 250, 0.3)",
                    textShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(45, 212, 191, 0.5), 0 4px 8px rgba(96, 165, 250, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(45, 212, 191, 0.4), 0 2px 4px rgba(96, 165, 250, 0.3)";
                  }}
                >
                  选购服务
                </button>
              </div>
            </div>


            {/* 右侧：卖家半身相展示区（用 img 避免 OSS 跨域 fetch 的 CORS 限制） */}

            <img
                  src={homePageAdsData?.[currentSellerIndex]?.pictureUrl || ''}
                  alt=""
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    height: "95vh",
                    width: "auto",
                  }}
            />
            {/* —— 右侧下载区结束 —— */}
          </div>
        </div>

        {!globalStore.staticMode && (homePageAdsData?.length ?? 0) > 0 && (
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              right: PAGE_INLINE_PADDING_PX,
              zIndex: 2,
              color: "#fff",
              textAlign: "right",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            <div style={{ fontSize: "20px", fontWeight: 600 }}>
              {homePageAdsData?.[currentSellerIndex]?.name || ""}
            </div>
            <div style={{ fontSize: "16px", opacity: 0.9 }}>
              {homePageAdsData?.[currentSellerIndex]?.major || ""}
            </div>
          </div>
        )}

        {/* 下滑提示 */}
        <div
          onClick={scrollToSecond}
          title="向下滚动"
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            bottom: "24px",
            width: "28px",
            height: "44px",
            borderRadius: "20px",
            border: "2px solid rgba(255,255,255,0.8)",
            cursor: "pointer",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            paddingTop: "6px",
            opacity: 0.9,
          }}
        >
          <div
            style={{
              width: "4px",
              height: "8px",
              borderRadius: "4px",
              background: "rgba(255,255,255,0.9)",
              animation: "scrollDot 1.6s ease-in-out infinite",
            }}
          />
          <style>
            {`
              @keyframes scrollDot {
                0% { transform: translateY(0); opacity: 1; }
                70% { transform: translateY(16px); opacity: 0; }
                100% { transform: translateY(0); opacity: 0; }
              }
            `}
          </style>
        </div>
      </section>

      {/* ====== 第二屏：价值与愿景（以图片为主，少量文字） ====== */}
      <section
        ref={secondRef}
        style={{
          padding: "72px 24px",
          minHeight: "min(100vh, 600px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "36px",
          background: "#ffffff",
        }}
      >
        <div
          style={{
            maxWidth: "1100px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              margin: 0,
              marginTop: "60px",
              fontSize: "36px",
              marginBottom: "30px",
              lineHeight: 1.2,
              letterSpacing: "-0.3px",
              color: "#0b1220",
            }}
          >
            不是所有工作都需要招聘正式员工
          </h2>
          <p
            style={{
              margin: "12px auto 0",
              maxWidth: "760px",
              color: "#5b6472",
              fontSize: "16px",
              lineHeight: 1.8,
            }}
          >
            少会议，多沟通；少文档，多演示；少内耗，多结果。
          </p>
        </div>

        {/* 3 列图卡（纯色占位） */}
        <div
          style={{
            maxWidth: "1100px",
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "22px",
          }}
        >
          {[
            { title: "拥抱可视化交付", desc: "定期开视频会议，用投屏演示代替日报，让工作可视化，还可以对齐GAP，加快迭代。" },
            { title: "替代算力型员工", desc: "企业成功路上80%的工作都和核心业务无关，雇佣圆领为您提供“灵活远程算力”，随用随停。" },
            { title: "低成本用好人才", desc: "圆领90%以上都是大城市返乡人才，一线城市的服务水准，四线城市的价格，省心省时又省钱。" },
          ].map((card, idx) => (
            <div
              key={idx}
              style={{
                border: "1px solid #eef0f3",
                borderRadius: "5px",
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                background: "#ffffff",
              }}
            >
              {/* 使用 img 避免 CachedImage fetch 触发 OSS CORS */}
              <img
                src={
                  idx === 0
                    ? "https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/40/408c9fed93e5133def9a1640c7e432c19dfd8ff52bba404300c48aaca62e447d.png"
                    : idx === 1
                    ? "https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/df/dffc437f831406fd61aef57ea0e763ac4a166c04065b9fb65c4de485405f999b.png"
                    : "https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/21/218369b057913f1cf8d69d245cf3586fe48a15b95772a358d5f37d90fe62f8cb.png"
                }
                style={{
                  width: "100%",
                  height: "220px",
                  borderRadius: "0px",
                  objectFit: "cover",
                }}
                alt={card.title}
              />
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <div style={{ fontSize: "18px", fontWeight: 600, color: "#0b1220" }}>
                  {card.title}
                </div>
                <div style={{ fontSize: "14px", color: "#5b6472", lineHeight: 1.7 }}>
                  {card.desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
 
    {/* ====== 第三屏：两种模式 ====== */}
    <section
      style={{
        padding: "80px 24px 100px",
        minHeight: "min(100vh, 600px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "40px",
        background: "#fbfcfe",
      }}
    >
      {/* 标题区 */}
      <div style={{ maxWidth: "900px", textAlign: "center" }}>
        <h2
          style={{
            margin: 0,
            fontSize: "32px",
            fontWeight: 700,
            color: "#0b1220",
            letterSpacing: "-0.3px",
          }}
        >
          两种模式 · 自由选择
        </h2>
        <p
          style={{
            margin: "16px auto 0",
            color: "#5b6472",
            fontSize: "16px",
            lineHeight: 1.8,
          }}
        >
          不论是完整的一次性的项目，还是与你的现有团队共同协作迭代既有的项目，圆领都能满足。
        </p>
      </div>

      {/* 两列模式卡片 */}
      <div
        style={{
          maxWidth: "1100px",
          width: "100%",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "28px",
        }}
      >
        {/* 超级个体 */}
        <div
          style={{
            border: "1px solid #eef0f3",
            borderRadius: "16px",
            background: "#fff",
            padding: "28px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: "22px",
                fontWeight: 600,
                color: "#0b1220",
              }}
            >
              购买单次任务商品
            </h3>
            <p
              style={{
                margin: "8px 0 0",
                fontSize: "14px",
                color: "#5b6472",
                lineHeight: 1.7,
              }}
            >
              对于一次性的项目，您可以购买单次任务，当然您也可以多次下单，完善你的项目。随买随用，按需购买无压力。
            </p>
          </div>
          {/* 图片占位 */}
          <CachedImage
            url="/home/5.png"
            style={{
              width: "100%", 
              borderRadius: "0px",
              objectFit: "cover",
            }}
            alt="超级个体"
            canOpenPreview={true}
          />
        </div>

        {/* 远程个体 */}
        <div
          style={{
            border: "1px solid #eef0f3",
            borderRadius: "16px",
            background: "#fff",
            padding: "28px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: "22px",
                fontWeight: 600,
                color: "#0b1220",
              }}
            >
              购买按月承揽商品
            </h3>
            <p
              style={{
                margin: "8px 0 0",
                fontSize: "14px",
                color: "#5b6472",
                lineHeight: 1.7,
              }}
            >
              对于需要批量购买服务的企业，建议您购买按月承揽商品，价格更优惠，也无需频繁下单。双方均可随时协商终止合作。
            </p>
          </div>
          {/* 图片占位 */}
          <CachedImage
            url="/home/6.png"
            style={{
              width: "100%", 
              borderRadius: "0px",
              objectFit: "cover",
            }}
            alt="远程个体"
            canOpenPreview={true}
          />
        </div>
      </div>
    </section>
       {/* ====== 第四屏：平台保障（安全合规） ====== */}
      <section
        style={{
          padding: "80px 24px 100px",
          background: "#ffffff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "48px",
        }}
      >
        {/* 标题 */}
        <div
          style={{
            maxWidth: "900px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "32px",
              fontWeight: 700,
              color: "#0b1220",
              letterSpacing: "-0.3px",
            }}
          >
             资金安全·合法合规·严选人才
          </h2>
          <p
            style={{
              margin: "16px auto 0",
              marginTop: "30px",
              color: "#5b6472",
              fontSize: "16px",
              lineHeight: 1.8,
            }}
          >
            圆领始终把资金安全和合法合规放在同样的第一位置，用的放心，才能无后顾之忧。
          </p>
        </div>

        {/* 六大保障 - 2 列布局 */}
        <div
          style={{
            maxWidth: "1000px",
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "28px 40px",
          }}
        >
          {[
            {
              icon: <PropertySafetyOutlined style={{ fontSize: 32, color: "#10b981" }} />,
              title: "平台资金托管",
              desc: "您支付的资金将托管在平台，你验收通过后，才会向卖家发放佣金。",
            },
            {
              icon: <UserOutlined style={{ fontSize: 32, color: "#3b82f6" }} />,
              title: "真实个人卖家",
              desc: "平台实名认证，确保每个卖家都是真实个人卖家，杜绝谈单式转包。",
            },
            {
              icon: <StopOutlined style={{ fontSize: 32, color: "#f59e0b" }} />,
              title: "杜绝任务转包",
              desc: "严控任务转包，一经发现，卖家将可能面临没收佣金、封号等处罚。",
            },
            {
              icon: <FileTextOutlined style={{ fontSize: 32, color: "#8b5cf6" }} />,
              title: "平台统一开票",
              desc: "订单完成后平台统一开具发票，增值税专用发票和普通发票均可开。",
            },
            {
              icon: <StarOutlined style={{ fontSize: 32, color: "#0ea5e9" }} />,
              title: "严选靠谱人才",
              desc: "每个超级个体都要经过微信笔试考察心智成熟度，只要“成年人”。",
            },
            {
              icon: <AuditOutlined style={{ fontSize: 32, color: "#ef4444" }} />,
              title: "交易五流合一",
              desc: "资金流、订单流、发票流，交付流，信息流五流合一，用的放心。",
            },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "16px",
              }}
            >
              <div style={{ flexShrink: 0 }}>{item.icon}</div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "17px",
                    fontWeight: 600,
                    color: "#0b1220",
                    marginBottom: "6px",
                  }}
                >
                  {item.title}
                </div>
                <div style={{ fontSize: "14px", color: "#5b6472", lineHeight: 1.6 }}>
                  {item.desc}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ marginTop: "20px" }}>
          <button
            onClick={() => setShowDownload(true)}
            style={{
              padding: "14px 28px",
              borderRadius: "6px",
              border: "0",
              background: "linear-gradient(135deg, #2DD4BF 0%, #60A5FA 100%)",
              color: "#fff",
              cursor: "pointer",
              fontSize: "15px",
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
            }}
          >
            选购技能服务
          </button>
        </div>
      </section>

      {/* ====== 第五屏：他们选择信任圆领 ====== */}
      <section
        style={{
          padding: "80px 24px 10px",
          background: "rgb(195, 255, 233)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "48px",
        }}
      >
        {/* 标题 */}
        <div
          style={{
            maxWidth: "900px",
            textAlign: "center",
          }}
        >
         
          <p
            style={{
              margin: "16px auto 0",
              marginTop: "10px",
              color: "#5b6472",
              fontSize: "32px",
              lineHeight: "1.8",
            }}
          >
            越来越多的企业正在拥抱圆领
          </p>
        </div>

        {/* 品牌Logo网格 */}
        <div
          style={{
            marginBlock:"20px",
            marginBottom:"70px",
            maxWidth: "1200px",
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "30px", 
            alignItems: "center",
            justifyItems: "center",
          }}
        >
          {[
            { logo: "/brands/1.png" },
            { logo: "/brands/2.png" },
            { logo: "/brands/3.png" },
            { logo: "/brands/4.png" },
            { logo: "/brands/5.png" }, 
          ].map((brand, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center", 
              }}
            >
              <CachedImage
                url={brand.logo}
                style={{
                  width: "130px",
                  height: "130px",
                  objectFit: "contain",
                  opacity: 0.7,
                }}
                alt="品牌logo"
                canOpenPreview={false}
              />
            </div>
          ))}
        </div>
 
      </section>

      {/* Download弹框 */}
      <Download 
        isOpen={showDownload}
        onClose={() => setShowDownload(false)}
        qrCodeUrl={globalStore.buyerAppQrCodeUrl}
      /> 
    </div>
  );
});

export default Home;